import { types as CustomExecutorActions } from '../store/actions/executor.actions';

export enum LessonState {
  STARTED = 'STARTED',
  PAUSED = 'PAUSED',
  STOPPED = 'STOPPED',
  INITIAL = 'INITIAL',
}

export enum NotsSystem {
  S80 = 'S80',
  CATIZ = 'CATIZ',
  HERMSYS = 'HERMSYS',
}

export enum LessonControlMessage {
  EXIT_PLAYER = 'EXIT_PLAYER',
  LOGOUT_ON_EXIT = 'LOGOUT_ON_EXIT',
  REPLAY_LESSON = 'REPLAY_LESSON',
  UPDATE_DIALOG_MONITOR = 'UPDATE_DIALOG_MONITOR',
}

export const IdleTimeout = 1000 * 60 * 20;

export enum S80Monitors {
  LOWER = 'lower',
  UPPER = 'upper',
}

export enum CatizMonitors {
  MainMapArea = 'MainMapArea',
  GFCSMapArea = 'GFCSMapArea',
}

export enum S80Tabs {
  UPPER = 'upper',
  LOWER = 'lower',
  DESK = 'desk',
}

export enum CatizTabs {
  MAIN = 'MAIN',
  TOUCHPANEL = 'TOUCHPANEL',
}

export enum SharedTabs {
  LESSON_CONTROL_PANEL = 'LESSON_CONTROL_PANEL',
}

export enum CatizDisplayLayoutModes {
  CMS = 'cms',
  GFCS1 = 'gfcs1',
  GFCS2 = 'gfcs2',
}

// TODO: add other Hermsys tabs here, but we are not using them at the moment in hermsys, so no hurry
export enum HermsysTabs {
  MAIN = 'MAIN',
}

export type SystemTabs = S80Tabs | CatizTabs | HermsysTabs | SharedTabs;

export type SystemMonitors = S80Monitors | CatizMonitors;

export enum MapRenderState {
  STARTED = 'started',
  COMPLETE = 'complete',
}

export const FieldsMode = {
  MOB: 'MOB',
  PERISCOPE: 'PERISCOPE',
  NAVAID: 'NAVAID',
  RADAR_LINK: 'RADAR_LINK',
};

export const RolesMap: any = {
  SONSUP: 'SONAR SUPERVISOR',
  SONOP1: 'SONAR OPERATOR 1',
  SONOP2: 'SONAR OPERATOR 2',
  SONOP3: 'SONAR OPERATOR 3',
  SONOP4: 'SONAR OPERATOR 4',
  SONOP5: 'SONAR OPERATOR 5',
  SONOP6: 'SONAR OPERATOR 6',
  TAHSOP: 'TAHS OPERATOR',
  SONPLY: 'SONAR PLAYBACK',
  TACT1: 'TACTICAL OPERATOR 1',
  TACT2: 'TACTICAL OPERATOR 2',
  TACT3: 'TACTICAL OPERATOR 3',
  TACT4: 'TACTICAL OPERATOR 4',
  LINKOP: 'LINK OPERATOR',
  SYSTEMSUP: 'SYSTEM SUPERVISOR',
  FCS1: 'FIRE CONTROL OPER 1',
  FCS2: 'FIRE CONTROL OPER 2',
  FCS3: 'FIRE CONTROL OPER 3',
  FCS4: 'FIRE CONTROL OPER 4',
  FCS5: 'FIRE CONTROL OPER 5',
  FCS6: 'FIRE CONTROL OPER 6',
  'OBT SUPERVR': 'OBT SUPERVR',
  'OBT ASSISTN': 'OBT ASSISTN 1',
  WPUPORT: 'WPUPORT',
  WPUSTBD: 'WPUSTBD',
  TMASUP: 'TMA SUPERVISOR',
  OFFLINE: 'OFFLINE',
  //Catiz Roles
  CO: 'Commanding Officer',
  TAO: 'Tactical Action Officer',
  CSC: 'Combat System Coordinator',
  TIC: 'Tactical Information Coordinator',
  ASWC: 'Anti-Submarine Warfare Coordinator',
  ASUWC: 'Anti-Surface Warfare Coordinator',
  AAWC: 'Anti-Air Warfare Coordinator',
  EWS: 'Electronic Warfare Supervisor',
  IDS: 'Identification Supervisor',
  ACS: 'Air Control Supervisor',
  TNGS: 'Training Supervisor',
  '3DSRC': '3D Surveillance Radar Controller',
  ASAC: 'Anti-Submarine Air Controller',
  ATACO: 'Air Tactical Controller',
  TLSC: 'Torpedo Launching System Controller',
  SSMSC: 'Surface-to-Surface Missile System Controller',
  GFCSC1: 'Gun Fire Control System Controller 1',
  SAMSC: 'Surface-to-Air Missile System Controller',
  GFCSC2: 'Gun Fire Control System Controller 2',
  'AIC/HCM1': 'Air Intercept Controller/Helos Controller Maritime 1',
  'AIC/HCM2': 'Air Intercept Controller/Helos Controller Maritime 2',
};

export const DisplayConstants = {
  GeneralDisplayArea: 'generalDisplayArea',
  DataEntryArea: 'dataEntryArea',
  UpperMonitor: 'upper',
  LowerMonitor: 'lower',
  Desk: 'desk',
  ScreenView: 'screenView',
  DialogView: 'dialogView',
};

export const PolygonTypes = {
  CIRCLE: 'circle',
  POLYLINE: 'polyline',
  POLYGON: 'polygon',
  CIRCULAR_SECTOR: 'circular-sector',
};

export interface Point {
  x: number;
  y: number;
}

export enum CommunicationMessageTypes {
  ExecutorAction = 'executor-action', // an action to be dispatched in other monitors.
  InputEvent = 'input-event', // an action to be sent to the executor for evaluation.
  PassiveEvent = 'passive-event',
  ActionForMainMonitor = 'action-for-main-monitor', // an action to be dispatched only in main monitor
  ControlMessage = 'control-message', // messages to and from LessonControlPanel, the channel itself is different for this
  KeyboardEvent = 'keyboard-event', // a keyboard event originating from touch panel
  FocusControlEvent = 'focus-control-event', // a event fired when focus changes in one of the monitors
  MonitorInitConfig = 'nots-monitor-initial-config', // initial synchronization between monitors to be ready
  LogControl = 'log-control',
}

export const S80ExecutorActions = {
  SetActiveMonitor: 'SetActiveMonitor',
  SignOnRole: 'SignOnRole',

  ShowTSDGeneralInformationArea: 'ShowTSDGeneralInformationArea',
  SetMonitorLayout: 'SetMonitorLayout',
  SetMFCCRoles: 'SetMFCCRoles',
  SignOffRole: 'SignOffRole',
  SignOffAllRoles: 'SignOffAllRoles',
  SetMap: 'SetMap',
  SystemSetTouchPanelToggleVariable: 'SystemSetTouchPanelToggleVariable',
  SetWindowDataItems: 'SetWindowDataItems',
  SystemDeleteWindowDataItem: 'SystemDeleteWindowDataItem',
  SystemUpdateWindowDataItems: 'SystemUpdateWindowDataItems',
  SystemUnselectWindowDataItems: 'SystemUnselectWindowDataItems',
  // // ShowTutorialInTutorialArea: 'ShowTutorialInTutorialArea',
  SystemShowTutorialArea: 'SystemShowTutorialArea',
  SystemHideTutorialArea: 'SystemHideTutorialArea',

  SystemShowTouchPanelVabArray: 'SystemShowTouchPanelVabArray',
  SetValueInMonitorField: 'SetValueInMonitorField',
  PushWindowButtonCaptureBT: 'PushWindowButtonCaptureBT',

  SystemSetMonitorLayout: 'SystemSetMonitorLayout',

  PrimaryHookPoint: 'PrimaryHookPoint',
  SecondaryHookPoint: 'SecondaryHookPoint',

  SystemSetLowerMonitorLED: 'SystemSetLowerMonitorLED',
  SystemShowMob: 'SystemShowMob',
  SystemHideMob: 'SystemHideMob',

  // Actions to set different areas of the screen in s80.
  SystemSetSonarWorkModeArea: 'SystemSetSonarWorkModeArea',
  SystemSetSonarCursorInfoArea: 'SystemSetSonarCursorInfoArea',
  SystemSetSonarShipInfoArea: 'SystemSetSonarShipInfoArea',
  SystemSetSonarAudioInfoArea: 'SystemSetSonarAudioInfoArea',
  SystemSetSonarAuxInfoArea: 'SystemSetSonarAuxInfoArea',
  SystemSetTacticalAuxInfoAreaNavaid: 'SystemSetTacticalAuxInfoAreaNavaid',
  SystemSetTacticalAuxInfoAreaMob: 'SystemSetTacticalAuxInfoAreaMob',
  SystemSetTacticalAuxInfoAreaPeriscope:
    'SystemSetTacticalAuxInfoAreaPeriscope',
  SystemSetTacticalSpareAreaPeriscope: 'SystemSetTacticalSpareAreaPeriscope',
  SystemSetTacticalSpareAreaRadarLink: 'SystemSetTacticalSpareAreaRadarLink',
  SystemSetSonarCSRAInfoArea: 'SystemSetSonarCSRAInfoArea',
  SystemSetTacticalCSRAInfoArea: 'SystemSetTacticalCSRAInfoArea',
  SystemSetSystemLayoutCSRAInfoArea: 'SystemSetSystemLayoutCSRAInfoArea',
  SystemSetSystemLayoutShipInfoArea: 'SystemSetSystemLayoutShipInfoArea',
  SystemSetWeaponCSRAInfoArea: 'SystemSetWeaponCSRAInfoArea',
  SystemSetWeaponShipInfoArea: 'SystemSetWeaponShipInfoArea',
  SystemSetObtShipInfoArea: 'SystemSetObtShipInfoArea',
  SystemSetLinkLayoutCSRAInfoArea: 'SystemSetLinkLayoutCSRAInfoArea',
  SystemSetLinkLayoutLinkStatusArea: 'SystemSetLinkLayoutLinkStatusArea',
  SystemSetTacticalShipInfoArea: 'SystemSetTacticalShipInfoArea',
  // TODO: Need to add implementation for this.
  SystemSetRoleInfoArea: 'SystemSetRoleInfoArea',
  SystemShowTacsitBallTabPosition: 'SystemShowTacsitBallTabPosition',
  SystemHideTacsitBallTabPosition: 'SystemHideTacsitBallTabPosition',
  SystemShowTacsitGeneralInfoArea: 'SystemShowTacsitGeneralInfoArea',
  SystemHideTacsitGeneralInfoArea: 'SystemHideTacsitGeneralInfoArea',
};

// Actions thrown by the executor, these don't have action creators.
// these are thrown by the executor.saga as soon as the executor gives these actions.
export const ExecutorActions = {
  ShowAlert: 'ShowAlert',
  SetImageInTacsit: 'SetImageInTacsit',
  SetActiveRole: 'SetActiveRole',
  SystemRemoveAlert: 'SystemRemoveAlert',
  SystemClearAllAlerts: 'SystemClearAllAlerts',
  UserSetWindowAttribute: 'UserSetWindowAttribute',
  SystemSetWindowAttributes: 'SystemSetWindowAttributes',
  SystemSetWindowCountdownAttribute: 'SystemSetWindowCountdownAttribute',
  ShowMultimediaText: 'ShowMultimediaText',
  // PushWindowButton: 'PushWindowButton',
  ShowWindow: 'ShowWindow',
  HideWindow: 'HideWindow',
  ShowHint: 'ShowHint',
  ShowNoGoZone: 'ShowNoGoZone',
  TouchPanelButtonOperation: 'TouchPanelButtonOperation',
  TouchPanelShowHidePanels: 'TouchPanelShowHidePanels',
  ShowCoastalLine: 'ShowCoastalLine',
  Continue: 'Continue',
  TouchPanelShowTextInTPTA: 'TouchPanelShowTextInTPTA',
  SetTrackAtPosition: 'SetTrackAtPosition',
  DisplayTrackThroughTrajectory: 'DisplayTrackThroughTrajectory',
  ShowImage: 'ShowImage',
  ShowVideo: 'ShowVideo',
  ShowCoverageArea: 'ShowCoverageArea',
  // SetWindowActiveTab: 'SetWindowActiveTab',
  SystemSetWindowVideo: 'SystemSetWindowVideo',
  SystemSetWindowTreeItems: 'SystemSetWindowTreeItems',
  // PushWindowToggleButton: 'PushWindowToggleButton',
  SystemSetWindowLabelImage: 'SystemSetWindowLabelImage',
  SystemPlaceTrackSymbolAtPosition: 'SystemPlaceTrackSymbolAtPosition',
  SystemDisplayTrackThroughTrajectory: 'SystemDisplayTrackThroughTrajectory',
  SystemChangeTrackSymbol: 'SystemChangeTrackSymbol',
  SystemRemoveTrack: 'SystemRemoveTrack',
  SystemDrawTrackCenteredCircle: 'SystemDrawTrackCenteredCircle',
  SystemDrawTrackRectangle: 'SystemDrawTrackRectangle',
  SystemConnectTrackGroup: 'SystemConnectTrackGroup',
  SystemDisconnectTrackGroup: 'SystemDisconnectTrackGroup',
  SystemUpdatePrimaryHookProperties: 'SystemUpdatePrimaryHookProperties',
  SystemUpdateSecondaryHookProperties: 'SystemUpdateSecondaryHookProperties',
  SystemRemovePolygon: 'SystemRemovePolygon',
  SystemRemovePolyline: 'SystemRemovePolyline',
  SystemRemoveCircle: 'SystemRemoveCircle',
  SystemRemoveCircularSector: 'SystemRemoveCircularSector',
  SystemRemoveWaypoint: 'SystemRemoveWaypoint',
  SystemPlaceWayPoint: 'SystemPlaceWayPoint',
  SetWaypointsFromResource: 'SetWaypointsFromResource',
  SystemPlacePoint: 'SystemPlacePoint',
  SystemPlaceAreaCircle: 'SystemPlaceAreaCircle',
  SystemPlacePolyline: 'SystemPlacePolyline',
  SystemPlaceAreaPolygon: 'SystemPlaceAreaPolygon',
  SystemPlaceAreaCircularSector: 'SystemPlaceAreaCircularSector',
  Pass: 'Pass', // This is a no OP Action thrown by the executor, we are adding this just as a hotfix for another problem
  EndOfLesson: 'EndOfLesson',

  // Not implemented
  ClearAlertMessageOnReviewAlertsPanel: 'ClearAlertMessageOnReviewAlertsPanel',
};

export const config = {
  ButtonClickDelay: 700,
  WindowShowDelay: 1000,
  ButtonTypeAnimationDelay: 100,
  NextActionDelay: 1000,
  DoAnimateTyping: true,
};

export const MonitorConfig = {
  SONAR: 'sonar',
  TACTICO: 'tactico',
  LINK: 'link',
  SISTEMA: 'sistema',
  WEAPON: 'weapon',
  OBT: 'obt',
  WPU: 'wpu',
};

export const ExecutorActionSymbol = 'ExecutorAction';

export const UndoableActions = [
  CustomExecutorActions.UI_USER_SET_WINDOW_ATTRIBUTE,
  CustomExecutorActions.TOGGLE_BUTTON_CLICK,
  CustomExecutorActions.UI_SET_PRIMARY_HOOK,
  CustomExecutorActions.UI_SET_SECONDARY_HOOK,
  CustomExecutorActions.UPDATE_TSD_ILLUMINATION,
  CustomExecutorActions.UPDATE_TSD_BLINKING,
];

export const ClearCheckPointAction = [
  ExecutorActions.UserSetWindowAttribute,
  ExecutorActions.TouchPanelButtonOperation,
];
